import { DeploymentSettingsPage } from "@/features/deployment-settings";

export function SettingsRoute() {
  return <DeploymentSettingsPage />;
}
